import { Box } from 'edenred-ui';
import styled from 'styled-components';

export const GridContainer = styled(Box)({
  display: 'grid',
  justifyContent: 'center',
  gridTemplateColumns: 'repeat(auto-fill, minmax(294px, 1fr))',
  gap: '24px',
  maxWidth: '100%'
});
